const queryForScrollTop = ['page']
const scrollToTop = {
  'vacancies': {
    query: ['page']
  }
}

const scrollSavePositionWithParamsChange = {
  'vacancies': ['directionId', 'categoriesIds', 'filters', 'dynamic'],
  'vacancies-with-filters': ['directionId', 'categoriesIds', 'filters', 'dynamic'],
  'vacancies-with-dynamic': ['directionId', 'categoriesIds', 'filters', 'dynamic'],
  'vacancies-with-filters&dynamic': ['directionId', 'categoriesIds', 'filters', 'dynamic'],
}

export default function scrollBehavior(to, from, savedPosition) {
  // debugger
  // const pageComponent = router.currentRoute.matched[router.currentRoute.matched.length - 1]
  // // console.log(pageComponent.components.default)
  // // pageComponent.components.default.$on('hook:mounted', () => {
  // //   console.log('@hook:mounted')
  // // })
  // pageComponent.instances.default.$on('@hook:created', () => {
  //   console.log('@hook:mounted')
  // })
  // debugger
  // console.log(this.app.$root)
  // this.app.$root.$on('@hook:created', () => {
  //         console.log('@hook:mounted')
  //       })
  // if(to.hash) {
  //   setTimeout(() => {
  //     console.log('setTimeout', savedPosition)
  //     VueScrollTo.scrollTo(to.hash)
  //   }, 1000)
  // }

  const toName = to.name ? to.name.replace('-double', '') : to.name
  const fromName =  from.name ? from.name.replace('-double', '') : from.name

  if (toName === fromName && scrollToTop.hasOwnProperty(toName)) {
    if (Array.isArray(scrollToTop[toName].query)) {
      for (const name of scrollToTop[toName].query) {
        if (to.query[name] !== from.query[name]) {
          return {x: 0, y: 0}
        }
      }
    }

    if (Array.isArray(scrollToTop[toName].params)) {
      for (const name of scrollToTop[toName].params) {
        if (to.params[name] !== from.params[name]) {
          return {x: 0, y: 0}
        }
      }
    }
  }

  if (
    scrollSavePositionWithParamsChange[toName] &&
    compareParams(to, from, scrollSavePositionWithParamsChange[toName])
  ) {
    return null
  }

  if (to.params.lang !== from.params.lang && toName === fromName) {
    return null
  }

  if (isSameRoutes(to, from)) {
    return null
  }

  if (savedPosition) {
    return savedPosition
  } else {
    return {x: 0, y: 0}
  }
}

function isSameRoutes(to, from) {
  if (to.path !== from.path) return false

  for (const queryName of queryForScrollTop) {
    if (to[queryName] !== from[queryName]) {
      return false
    }
  }

  return true
}

function compareParams(to, from, params) {
  for (const name in to.params) {
    if (!params.includes(name)) {
      let toPrams = Array.isArray(to.params[name]) ? to.params[name].join('/') : to.params[name]
      let fromPrams = Array.isArray(from.params[name]) ? from.params[name].join('/') : from.params[name]

      if (toPrams !== fromPrams) {
        return false
      }
    }
  }

  const toName = to.name ? to.name.replace('-double', '') : to.name
  const fromName =  from.name ? from.name.replace('-double', '') : from.name
  if(toName === fromName) {
    return true
  }

  return (Object.values(to.params).join('') && Object.values(from.params).join(''))
}
